<app-d-form-group (control)="onControlChange($event)" (cancel)="onCancel($event)" [formArray]="addSectorTargetForm" (submit)="onSubmit($event)"></app-d-form-group>
